<template>
  <div class="flex justify-between">
    <button
      class="px-0 font-bold text-[#171717] social-btn bg-b95
            al-btn sm:px-8 lg:px-12 ml-2 w-full"
      @click="proxyRedirect('google')"
    >
      <SvgIcon class="-mt-[2px]" icon="google-al" />
      Google
    </button>
    <button
      class="px-0 text-[#171717] social-btn bg-b95 al-btn sm:px-8 lg:px-12 ml-2 w-full"
      @click="proxyRedirect('facebook')"
    >
      <SvgIcon class="mr-2 -mt-[2px]" icon="facebook-no-circle" />
      Facebook
    </button>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';
import SocialSignOn from '@/mixins/SocialSignOn';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';

export default {
  components: {
    SvgIcon,
  },
  mixins: [
    SocialSignOn,
  ],
  props: {
    rememberMe: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    proxyRedirect(provider) {
      eventTracker(analyticsEvents.clickOnSocialLogin, { provider });

      this.redirectTo(provider, this.rememberMe);
    },
  },
};
</script>

<style scoped>
.-mt-\[2px\] {
  margin-top: -2px;
}
.text-\[\#171717\] {
  color: #171717;
}
.text-\[\#4664BD\] {
  color: #4664BD;
}
.social-btn {
    width: 155px;
    transition: 0.3s all;
}
.social-btn:hover {
  opacity: 0.9;
}
@screen sm {
  .social-btn {
    width: 180px;
  }
}
</style>
